import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerAllInstagramFeedPosts.graphql';
import { Query, QueryinfluencerAllInstagramFeedPostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerAllInstagramFeedPostsQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerAllInstagramFeedPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerAllInstagramFeedPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerAllInstagramFeedPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerAllInstagramFeedPostsArgs>
): QueryResult<Query, QueryinfluencerAllInstagramFeedPostsArgs> & {
  getInfluencerAllInstagramFeedPosts: LazyQueryExecFunction<Query, QueryinfluencerAllInstagramFeedPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerAllInstagramFeedPosts, result] = useLazyQuery<Query, QueryinfluencerAllInstagramFeedPostsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInfluencerAllInstagramFeedPosts, ...result };
};

export const useInfluencerAllInstagramFeedPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerAllInstagramFeedPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerAllInstagramFeedPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerAllInstagramFeedPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerAllInstagramFeedPosts };
};
// Suspense Query Hooks
export const useInfluencerAllInstagramFeedPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerAllInstagramFeedPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerAllInstagramFeedPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
